import type { CompanyHoliday, SnapshotEntry } from '~/lib/api/types'
import styles from './holiday-banner.module.scss'

type Props = {
  holiday: CompanyHoliday
  outEntries: SnapshotEntry[]
}

export function HolidayBanner({ holiday, outEntries }: Props) {
  return (
    <section className={styles.banner} aria-labelledby="holiday-heading">
      <h2 id="holiday-heading" className={styles.heading}>
        Politech is closed today: {holiday.name}.
      </h2>
      <p className={styles.subtext}>OOO and check-ins won&apos;t fire.</p>

      {outEntries.length > 0 && (
        <ul className={styles.list}>
          {outEntries.map(entry => (
            <li key={entry.user.slack_user_id} className={styles.listItem}>
              {entry.user.display_name ?? entry.user.slack_user_id}
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
